(function () {
	function close_nav(button) {
		document.body.classList.remove('is-nav-open');
		button.setAttribute('aria-expanded', 'false');
		button.setAttribute('aria-label', 'Open menu');
	}

	function open_nav(button) {
		document.body.classList.add('is-nav-open');
		button.setAttribute('aria-expanded', 'true');
		button.setAttribute('aria-label', 'Close menu');
	}

	function init_nav() {
		var button = document.querySelector('[data-nav-toggle]');
		var panel = document.querySelector('[data-nav-panel]');
		if (!button || !panel) return;

		button.addEventListener('click', function () {
			if (button.getAttribute('aria-expanded') === 'true') {
				close_nav(button);
				return;
			}

			open_nav(button);
		});

		panel.addEventListener('click', function (event) {
			if (event.target.closest('a')) {
				close_nav(button);
			}
		});

		document.addEventListener('click', function (event) {
			if (!document.body.classList.contains('is-nav-open')) return;
			if (button.contains(event.target) || panel.contains(event.target)) return;

			close_nav(button);
		});

		document.addEventListener('keydown', function (event) {
			if (event.key !== 'Escape') return;
			if (!document.body.classList.contains('is-nav-open')) return;

			close_nav(button);
			button.focus();
		});
	}

	function init_disclosures() {
		document.querySelectorAll('[data-disclosure]').forEach(function (root) {
			var button = root.querySelector('[data-disclosure-toggle]');
			var panel = root.querySelector('[data-disclosure-panel]');
			if (!button || !panel) return;

			var is_open = root.getAttribute('data-disclosure-default') === 'open';
			button.setAttribute('aria-expanded', is_open ? 'true' : 'false');
			panel.hidden = !is_open;

			button.addEventListener('click', function () {
				var next_open = button.getAttribute('aria-expanded') !== 'true';
				button.setAttribute('aria-expanded', next_open ? 'true' : 'false');
				panel.hidden = !next_open;
			});
		});
	}

	function open_consent_settings(trigger) {
		if (window.CookieConsent) {
			if (typeof window.CookieConsent.showPreferences === 'function') {
				window.CookieConsent.showPreferences();
				return;
			}

			if (typeof window.CookieConsent.showPreferencesModal === 'function') {
				window.CookieConsent.showPreferencesModal();
				return;
			}
		}

		var fallback = trigger.getAttribute('data-consent-fallback');
		if (fallback) {
			window.location.href = fallback;
		}
	}

	function init_consent_bridge() {
		document.querySelectorAll('[data-consent-settings]').forEach(function (trigger) {
			trigger.addEventListener('click', function (event) {
				event.preventDefault();
				open_consent_settings(trigger);
			});
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		init_nav();
		init_disclosures();
		init_consent_bridge();
	});
})();
